import AgenticateDemo from './AgenticateDemo';

function App() {
  return <AgenticateDemo />;
}

export default App;
